export default "__VITE_ASSET__CJ$tWN6d__"